import { render, staticRenderFns } from "./SaveRoute.vue?vue&type=template&id=177b5a50&scoped=true&"
import script from "./SaveRoute.vue?vue&type=script&lang=js&"
export * from "./SaveRoute.vue?vue&type=script&lang=js&"
import style0 from "./SaveRoute.vue?vue&type=style&index=0&id=177b5a50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b5a50",
  null
  
)

export default component.exports